<template>
  <section v-if="orderList.length && orderList.length > 9" class="cms-client-atmosphere" :style="`background: ${compProps.backgroundColor};top: ${getTop}px`" ref="atmosphere">
    <p class="atmosphere-text" :class="isAndroidText" :style="{color: compProps.textColor}">{{showOrder}}</p>
  </section>
</template>

<script>
import { errorReport } from '@/utils/index.js'
import { isAndroid } from '@/utils/index'
import { Sniff } from '@/utils/q_sniff'
export default {
  data() {
    return {
      orderList: [],
      showOrder: '',
      orderIndex: 1
    }
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    channel: {
      type: String,
      default: function() {
        return '2'
      }
    },
    // 默认置顶高度
    defaultTop: {
      type: Number,
      default: 10
    }
  },
  computed: {
    getTop() {
      const { hastitle } = this.$route.query
      let HEADER_HEIGHT = 56 // 去哪儿标题栏高度
      const TJPC_HEIGHT = 40 // 途家pc导航栏高度
      let DEFAULT_HEAGHT = this.defaultTop

      if (this.channel === '1') {
        return TJPC_HEIGHT + DEFAULT_HEAGHT
      }
      // eslint-disable-next-line
      if (hastitle == 1) {
        return HEADER_HEIGHT + Sniff.statusBarH
      }
      // eslint-disable-next-line
      if (hastitle == 2) {
        return DEFAULT_HEAGHT
      }
      if (this.platform === 6) {
        return HEADER_HEIGHT + Sniff.statusBarH
      }
      return DEFAULT_HEAGHT
    },
    isAndroidText() {
      if (isAndroid) {
        return 'isAndroid'
      }
      return ''
    }
  },
  async created() {
    switch (process.env.VUE_APP_LOCAL) {
    case 'T':
      try {
        const { fetchOrderList } = require('@/services/order')
        const res = await fetchOrderList()
        if (res.errcode === 0) {
          const orderList = res.data
          orderList.length && (this.orderList = orderList)
          this.showOrder = orderList[0]
        }
      } catch (e) {
        errorReport(e)
      }
      break
    case 'Q':
      try {
        const { fetchOrderList } = require('@/services/q_order')
        const res = await fetchOrderList()
        if (res.ret) {
          const orderList = res.data && res.data.scrollBars
          if (orderList.length) {
            orderList.map((item) => {
              this.orderList.push(`${item.phone}刚预定了一间民宿 优惠已减${item.promoSum}元`)
            })
            this.showOrder = this.orderList[0]
          }
        }
      } catch (e) {
        console.log(e)
      }
      break
    }
  },
  updated() {
    if (this.$refs.atmosphere && !this.hasEvent) {
      this.hasEvent = true
      this.$refs.atmosphere.addEventListener('animationiteration', this.orderAnimate, false)
    }
  },
  methods: {
    orderAnimate() {
      const orderList = this.orderList
      if (orderList.length) {
        if (this.orderIndex > orderList.length - 1) {
          this.orderIndex = 0
        }
        this.showOrder = orderList[this.orderIndex]
        this.orderIndex++
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cms-client-atmosphere {
  position: absolute;
  left: 0;
  padding: 0 7px;
  border-radius: 9px;
  z-index: 99;
  visibility: hidden;
  height: 18px;
  line-height: 18px;
  font-size: 11px;
  color: #ffffff;
  white-space: nowrap;
  background-color: #ed3f44;
  animation: barrageLeftToRight 4s ease 0s infinite;
  // .isAndroid {
  //   padding-top: 1px;
  // }
}
.atmosphere-text {
  padding: 0;
  margin: 0;
}
@keyframes barrageLeftToRight {
  0% {
    visibility: visible;
    transform: translateX(-20rem);
  }
  90% {
    opacity: 1;
    visibility: visible;
    transform: translateX(0.6rem);
  }
  100% {
    opacity: 0;
    visibility: visible;
    transform: translateX(0.6rem);
  }
}
</style>
